// Constants
import { STATUS_CODES, STATUS_MSG, ERROR_MSG, USER_ROLES } from '@/app/constants/status-constants';

// services
import userService from '@/app/services/main/user/user-service.js';
import authLoginService from "@/app/services/auth/auth-login/auth-login-service.js"
import addressFinderAutocompleteService from "@/app/services/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js";

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins";
// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

export default {
    name: 'ProfileContainer',
    mixins: [ toastMessageMixins, userMixins, inputTextMixins],
    data() {
		return {
            isAPILoading: false,
            isEditAPILoading: false,
            firstName: '',
            lastName: '',
            emailAddress: '',
            userID: null,
			isShowDelete: true,
			mobileNumber: null,
			mobileNumberIsValid: true,
			userAddress: '',
			userInitialAddress: '',
			addressData: null,
			isAddressLoading: false,
			isAddressMetadataLoading: false,
			addressList: [],
			postcode: '',
			addressDetails: '',
			suburb: '',
			state: '',
		}
    },
    computed: {
		validationRules() {
			let fields = {
				userID: {},
				firstName: {},
				lastName: {}
			}

			// if(this.isShowDelete) {
			// 	fields.mobileNumber = {}
			// 	fields.userAddress = {}
			// }

            fields = vuelidateUtil.setFieldsRequired(fields, true);
            
			return fields;
		},
		isUserInfoChange() {
			if(this.isShowDelete) {
				return (
					this.lastName === this.userDetails.lastName && 
					this.firstName === this.userDetails.firstName &&
					this.addressData === this.userDetails.address && 
					this.mobileNumber === this.userDetails.mobileNumber );
			} else {
				return (
					this.lastName === this.userDetails.lastName && 
					this.firstName === this.userDetails.firstName );
			}
		},
    },
	async created() {
       await this.getUserDetailsAPI();
       this.populateData();
	   if(this.isShowDelete) {
	   	await this.getUserAddress();
	   }
    },
	watch: {
		userAddress() {
			if(!this.userAddress)
				this.addressData = null
		},
	},
    methods: {
    	populateData() {
    		const {
				firstName,
				lastName,
				emailAddress,
				id,
				userRole,
				address,
				postcode,
				suburb,
				mobileNumber
			 } = this.userDetails;
				
			 this.isShowDelete = userRole !== USER_ROLES.BREEDER;
			 this.firstName = firstName;
			 this.lastName = lastName;
			 this.emailAddress = emailAddress;
			 this.userID = id;
			 if(this.isShowDelete) {
				this.postcode = postcode;
				this.suburb = suburb;
				this.addressData = address;
				this.mobileNumber = mobileNumber;
			 }
			
	    },
        logoutUser() {
            this.$store.dispatch("logout");
		},
		async postUserAddress() {
			const { firstName, lastName } = this.userDetails

			let address = []
			if(this.userAddress) {
				if(this.userAddress.id !== this.userInitialAddress.id) {
					let shipAddress = this.userAddress
			
					shipAddress.firstName = firstName
					shipAddress.lastName = lastName
					shipAddress.mobileNumber = this.mobileNumber.replace("-", "")
					shipAddress.isDefault = 1
					shipAddress.addressType = "PROFILE"
					shipAddress.address = shipAddress.full_address
					shipAddress.referenceId = shipAddress.canonical_address_id
					shipAddress.postcode = this.postcode
					shipAddress.suburb = this.suburb
					shipAddress.state = this.state
					address = [shipAddress]
					userService.postUserAddress({ address }).then(async res =>  {
						await this.getUserAddress()
					})
				}
				
			} else {
				if(this.userInitialAddress) {
					const details = {
						addressIds:[this.userInitialAddress.id],
						addressType: "PROFILE"
					};
	
					userService.deleteUserDefaultAddresses(details).then(async res =>  {
						await this.getUserAddress()
					})
					
				}	
			}
		},
		async getUserAddress() {
			userService.getUserAddress().then((res) => {
				if (res.status === 200) {
					const { userAddress: userAddressDetails } = res.data.addressDetails

					const  tempAddress = userAddressDetails
					
					if (tempAddress.address === this.userDetails.address) {
						if (tempAddress.referenceId) {
							this.userAddress = {
								id: tempAddress.referenceId,
								full_address: tempAddress.address,
							}						
						}

						this.userInitialAddress = tempAddress;

						this.postcode = tempAddress.postcode
						this.suburb = tempAddress.suburb
						this.state = tempAddress.state
						this.addressDetails =  tempAddress
					}
				}
			})
		},
		isObjEmpty(obj) {
			// Check if obj is null or undefined
			if (obj === null || obj === undefined) {
				return true;
			}
		
			// Check if obj is an object and has no own properties
			return Object.keys(obj).length === 0;
		},

        updateUser() {
            if (this.$v.$invalid || this.isAPILoading || this.isUserInfoChange) {
                return;
            }

            this.$swal({
				imageHeight: '30px',
				title: 'Are you sure you want to update your user profile?',
				imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
				showCancelButton: true,
				confirmButtonColor: '#4B8BFF',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Confirm',
				reverseButtons: true

			})
			.then(result => {
				if (result.value) {
					this.isEditAPILoading = true;
					let userAddressValue = ''
					if(this.userAddress) {
						userAddressValue = this.userAddress.fullAddress || this.userAddress.full_address
					}

                    // Call API update details
                    let body = {
                        'firstName': this.firstName,
                        'lastName': this.lastName,
						'address': userAddressValue,
						'suburb': this.suburb, 
						'postcode': this.postcode,
						'mobileNumber': this.mobileNumber,
						'state': this.state,
                    }

                    userService.putUserDetails(this.userID, body)
                    .then(async res => {
                        if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {

							// isShowDelete means that the role of the user is NOT a breeder
							// no need to call this since we don't update the addresses of the breeder AND if the user didn't change the initial address
							if(this.isShowDelete){
								await this.postUserAddress()
							}

                            // refresh user details
                            await this.getUserDetailsAPI();

							this.showGenericSuccessToast();
                        } else {
							const { ERROR_UPDATE_USER } = this.toastMessages.user();
							this.showAPIErrorToast(ERROR_UPDATE_USER, res);
                        }
                    }).finally(() => {
						this.isEditAPILoading = false;
					})
				}
			});
        },
		deleteUser () {
			this.$swal({
				imageHeight: '30px',
				title: 'Are you sure you want to delete your account?',
				imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
				input: 'password',
				inputPlaceholder: "Password",
				showCancelButton: true,
				confirmButtonColor: '#4B8BFF',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				allowOutsideClick: false,
				preConfirm: async (txtInput) => {
					try {
						if (!txtInput) {
							this.$swal.showValidationMessage('Password cannot be empty');
						} else {
								const authDetails = {
									email: this.emailAddress,
									password: txtInput,
								}
							const authUserData =  await authLoginService.putAuthLogin(authDetails)
							if (authUserData.data.status === STATUS_MSG.AUTH_SERVICE_STATUS_SUCCESS_MSG) {
								this.$store.commit("setUserToken", authUserData.data.jwt)
								const userData = await  userService.putDeactivateUser()
								if (userData.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
									this.$store.commit("clearUserToken")
								} else {
									this.$swal.showValidationMessage(userData);
								}
							} else {
								this.$swal.showValidationMessage(authUserData.data.message);
							}
						}
						return txtInput;
					} catch (error) {
						this.$swal.showValidationMessage(`
						Request failed: ${error}
					  `);
					}
				},
			})
			.then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: `You have successfully deleted your account`,
						imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
						allowOutsideClick: false,
					  }).then((result) => {
						/* Read more about handling dismissals below */
						
					this.$router.push("/login");
					});
				}
				
			});
		},
		onPasteMobileNumber(event) {
			event.preventDefault(); // Prevent default paste behavior
			const pastedText = event.clipboardData.getData('text/plain');

			const formatMobileNumberOnPaste = this.formatMobileNumberOnPaste(pastedText)
			event.target.value = formatMobileNumberOnPaste;
		},
		checkFormat() {
            let mobileNumber = this.mobileNumber;
            let validMobile = this.mobileNumberIsValid;

            // this.$v.mobileNumber.$touch();

            let regexp = /^\d{4}-\d{6}$/;

            if (mobileNumber !== null && mobileNumber !== "") {
                validMobile = regexp.test(mobileNumber);
            } else {
                validMobile = true;
            }

            this.mobileNumberIsValid = validMobile;
        },

		mobileNumberFormat(event) {
            this.mobileNumberIsValid = true;

			this.mobileNumber = this.formatMobileNumberOnChange(event);
		},
		// Address
        findAddress(address) {
            if (address) {
                this.isAddressLoading = true;

                this.delayTyping(() => {
                    this.getAutocompleteAddress(address);
                });
            }
        },

		getAutocompleteAddress(address) {
            addressFinderAutocompleteService
                .getAutocompleteAddress(address)
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.addressList = res.data.completions.map((item) => {
                            let tempAddress = item.full_address;
                            item.displayAddress = tempAddress;
                            item.label = item.id;
                            return item;
                        });
                        this.isAddressLoading = false;
                    } else {
                        const { ERROR_GET_ADDRESS } =
                            this.toastMessages.addressFinder();
                        this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
                        this.isAddressLoading = false;
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                    this.isAddressLoading = false;
                });
        },

		async onBlur(field) {
            if (field === "address") {

                if (this.userAddress) {
                    await this.getAddressMetaData(this.userAddress);
                }
            }
        },

		async setSelectedAddress() {
            if (this.userAddress) {
                await this.getAddressMetaData(this.userAddress);
            }
        },

		async getAddressMetaData(address) {
			this.isAddressMetadataLoading = true;

            addressFinderAutocompleteService
                .getAddressMetaData(address.id)
                .then((res) => {

                    if (res.status === STATUS_CODES.SUCCESS) {
                        const { locality_name, postcode, full_address, state_territory, address_line_1, address_line_2, lga_name} = res.data;
                        this.userAddress.displayAddress = full_address;
                        this.userAddress.fullAddress = full_address;
						this.userAddress.addressLine1 = address_line_1;
						this.userAddress.addressLine2 = address_line_2;
						this.userAddress.cityTown = lga_name,
						this.userAddress.countryCode = "AU",
                        this.postcode = postcode
                        this.suburb = locality_name
						this.state = state_territory
						this.addressData = full_address;
						return res.data
                    } else {
                        const { ERROR_GET_ADDRESS } =
                            this.toastMessages.addressFinder();
                        this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
                        this.isAddressLoading = false;
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                    this.isAddressLoading = false;
                }).finally(() => {
					this.isAddressMetadataLoading = false;
				})
        },
    },
    beforeRouteLeave(to, from, next) {
		const firstName = this.userDetails.firstName !== this.firstName;
		const lastName = this.userDetails.lastName !== this.lastName;
		const mobileNumber = (this.userDetails.mobileNumber !== this.mobileNumber) && this.mobileNumber;
		const address = (this.userDetails.address !== this.addressData) && this.addressData;

		if ((firstName || lastName || mobileNumber || address) && 
			to.path !== '/login') {
			this.$swal({
				imageHeight: '30px',
				title: 'You have unsaved changes!',
				text: 'Are you sure you want to leave this page?',
				imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
				showCancelButton: true,
				confirmButtonColor: '#4B8BFF',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Proceed',
				reverseButtons: true

			})
				.then(result => {
					if (result.value) {
						next(true);
					} else {
						next(false);
					}
				});
		} else {
			next(true);
		}
    },
	validations() {
		return this.validationRules;
	}
}
